import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Buttons';
import { ButtonVariant } from '@/shared/components/Buttons/types';

const ViewFacilityErrorScreen = () => {
  const [animationData, setAnimationData] = useState<object | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    import('../../../../assets/lottie/somethingWetWrong.json')
      .then((module) => {
        setAnimationData(module.default);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="flex flex-col items-center gap-5 justify-center h-screen bg-white">
      {animationData && !isLoading ? (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: '30%', height: '30%' }}
        />
      ) : (
        <div
          className="flex items-center justify-center"
          style={{ width: '50%', height: '50%' }}
        >
          <div className="text-gray-400">Ładowanie...</div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-1">
        <h1
          className="text-bodyLarge font-medium text-center"
          style={{ color: '#474A4C' }}
        >
          Coś poszło nie tak...
        </h1>
        <p className="text-bodyLarge text-on-surface-variant text-center">
          Nie udało się w tej chwili załadować danych placówki.
        </p>
      </div>
      <Button
        label="Odśwież"
        className="hover:cursor-pointer"
        variant={ButtonVariant.Primary}
        size="Small"
        onClick={() => window.location.reload()}
      />
    </div>
  );
};

export default ViewFacilityErrorScreen;
